<template>

    <div class="row no-gutters justify-content-center">
        <div class="col-12 col-md-12 col-lg-12 col-xl-9 d-flex justify-content-between align-items-center mt-4">
            <div class="d-flex justify-content-between align-items-center">
                <a href="/" class="link" title="IOUU">
                    <i class="ico-iouu" />
                </a>
                <h1>GUIA RECOLHIMENTO DARF</h1>
            </div>
            <div class="d-flex" id="sumir" >
                <button class="btn btn-link" onclick="javascript:history.go(-1);">
                    <i class="fas fa-angle-left"></i>
                    Voltar
                </button>
                <button class="btn btn-secondary" v-if="encontrado" onclick="javascript: document.getElementById('sumir').style='display:none!important;'; window.print();">
                    <i class="fas fa-print"></i>
                    IMPRIMIR
                </button>
            </div>

        </div>
        <div class="divider"></div>
        <div class="col-12 col-md-12 col-lg-12 col-xl-9" v-if="encontrado">
            <table>
                <tbody>
                    <tr>
                        <td rowspan="3">
                            <div class="item-header">
                                <figure>
                                    <img src="/static/assets/images/brasao-br.png" alt="">
                                </figure>
                                <div>
                                    <strong>
                                        MINISTÉRIO DA FAZENDA<br>
                                        SECRETARIA DA RECEITA FEDERAL
                                    </strong>
                                    <strong>Documento de Arrecadação de Receitas Federais</strong>
                                    <strong>DARF</strong>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>02</strong>
                                    <small>PERÍODO DE APURAÇÃO</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        
                        <td class="align-middle align-right">&nbsp;{{getDataVencimento(this.PagAtual.Data)}}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>03</strong>
                                    <small>NÚMERO DO CPF OU CNPJ</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">&nbsp;{{formatCPF(this.infosDarf.Investidor.Cpf)}}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>04</strong>
                                    <small>CÓDIGO  DA  RECEITA</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">8053</td>
                    </tr>
                    <tr>
                        <td rowspan="2">
                            <span class="m-print">
                                <strong>01</strong>
                                <small>NOME / TELEFONE</small>
                            </span>
                            
                            <p>{{this.infosDarf.Investidor.NomeCompleto}} / {{this.infosDarf.Investidor.Celular}} </p>
                        </td>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>05</strong>
                                    <small>NÚMERO  DE REFERÊNCIA</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">&nbsp;</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>06</strong>
                                    <small>DATA DE VENCIMENTO</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                      
                        <td class="align-middle align-right">{{getDataApuracao(this.PagAtual.Data)}}&nbsp;{{this.DataVencimento}}</td>
                    </tr>
                    <tr>
                        <td rowspan="2">
                            <p>#{{this.infosDarf.Solicitacao.IdOportunidade}} - {{companyName(this.infosDarf.Solicitacao)}}</p>
                        </td>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>07</strong>
                                    <small>VALOR DO PRINCIPAL</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">{{this.infosDarf.Valor}}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>08</strong>
                                    <small>VALOR DA MULTA</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">&nbsp;0,00</td>
                    </tr>
                    <tr>
                        <td class="text-center align-middle atencao" rowspan="4">
                            <strong>ATENÇÃO</strong>
                            <p>É vedado o recolhimento de tributos administrados pela Secretaria da Receita Federal do Brasil (RFB) cujo valor total seja inferior a R$ 10,00. Ocorrendo tal situação, adicione esse valor  ao  tributo  de  mesmo  código  de  períodos  subseqüentes,  até que o total seja igual ou superior a R$ 10,00.</p>
                        </td>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>09</strong>
                                    <small>VALOR DOS JUROS E/OUENCARGOS DL - 1.025/69</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">&nbsp;0,00</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>10</strong>
                                    <small>VALOR TOTAL</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">{{this.infosDarf.Valor }}</td>
                    </tr>
                    <tr>
                        <td colspan="2" height="100">
                            <span class="m-print">
                                <strong>11</strong>
                                <small>AUTENTICAÇÃO  BANCÁRIA  (Somente nas 1ª e 2ª vias)</small>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

         <div class="col-12 col-md-12 col-lg-12 col-xl-9" v-if="encontrado">
            <table>
                <tbody>
                    <tr>
                        <td rowspan="3">
                            <div class="item-header">
                                <figure>
                                    <img src="/static/assets/images/brasao-br.png" alt="">
                                </figure>
                                <div>
                                    <strong>
                                        MINISTÉRIO DA FAZENDA<br>
                                        SECRETARIA DA RECEITA FEDERAL
                                    </strong>
                                    <strong>Documento de Arrecadação de Receitas Federais</strong>
                                    <strong>DARF</strong>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>02</strong>
                                    <small>PERÍODO DE APURAÇÃO</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        
                        <td class="align-middle align-right">&nbsp;{{getDataVencimento(this.PagAtual.Data)}}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>03</strong>
                                    <small>NÚMERO DO CPF OU CNPJ</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">&nbsp;{{formatCPF(this.infosDarf.Investidor.Cpf)}}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>04</strong>
                                    <small>CÓDIGO  DA  RECEITA</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">8053</td>
                    </tr>
                    <tr>
                        <td rowspan="2">
                            <span class="m-print">
                                <strong>01</strong>
                                <small>NOME / TELEFONE</small>
                            </span>
                            
                            <p>{{this.infosDarf.Investidor.NomeCompleto}} / {{this.infosDarf.Investidor.Celular}} </p>
                        </td>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>05</strong>
                                    <small>NÚMERO  DE REFERÊNCIA</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">&nbsp;</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>06</strong>
                                    <small>DATA DE VENCIMENTO</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                      
                        <td class="align-middle align-right">&nbsp;{{this.DataVencimento}}</td>
                    </tr>
                    <tr>
                        <td rowspan="2">
                            <p>#{{this.infosDarf.Solicitacao.IdOportunidade}} - {{companyName(this.infosDarf.Solicitacao)}}</p>
                        </td>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>07</strong>
                                    <small>VALOR DO PRINCIPAL</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">{{this.infosDarf.Valor}}</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>08</strong>
                                    <small>VALOR DA MULTA</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">&nbsp;0,00</td>
                    </tr>
                    <tr>
                        <td class="text-center align-middle atencao" rowspan="4">
                            <strong>ATENÇÃO</strong>
                            <p>É vedado o recolhimento de tributos administrados pela Secretaria da Receita Federal do Brasil (RFB) cujo valor total seja inferior a R$ 10,00. Ocorrendo tal situação, adicione esse valor  ao  tributo  de  mesmo  código  de  períodos  subseqüentes,  até que o total seja igual ou superior a R$ 10,00.</p>
                        </td>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>09</strong>
                                    <small>VALOR DOS JUROS E/OUENCARGOS DL - 1.025/69</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">&nbsp;0,00</td>
                    </tr>
                    <tr>
                        <td>
                            <div class="item">
                                <span>
                                    <strong>10</strong>
                                    <small>VALOR TOTAL</small>
                                </span>
                                <span>→</span>
                            </div>
                        </td>
                        <td class="align-middle align-right">{{this.infosDarf.Valor }}</td>
                    </tr>
                    <tr>
                        <td colspan="2" height="100">
                            <span class="m-print">
                                <strong>11</strong>
                                <small>AUTENTICAÇÃO  BANCÁRIA  (Somente nas 1ª e 2ª vias)</small>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        

         <div class="col-12 col-md-12 col-lg-12 col-xl-9 item-center-darf" v-if="Naoencontrado">
          <h1>Darf não encontrada</h1>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import * as mutationTypes from '@/store/mutation-types.js'
    import ApiClientGo from "@/utils/api-client-go";
    import ApiHub from "@/utils/hub-consulta-client";
    import ApiClient from '../utils/api-client'
    import Masker from '@/utils/masker'
    export default {
 
    data(){
            return {
                encontrado: false,
                Naoencontrado: false,
                infosDarf:{},
                PagAtual:{},
                wallet:{},
                DataApuracao: null,
                DataVencimento: null
            }
        },
    
    methods: { 

         companyName(solicitacao) {
              let name;

              if(solicitacao == null) {
                name = ""
              } else if (solicitacao.TipoEmprestimo == "emprestimo-de-impacto") {
                name = solicitacao.Impacto.NomeEmpresa;

              } else if (solicitacao.TipoEmprestimo == "emprestimo-social") {

                    if(solicitacao.Social.RazaoSocial == "")
                        name = solicitacao.Social.NomeCompleto;
                    else
                        name = solicitacao.Social.RazaoSocial;
              } else {

                if(solicitacao.Empresa.NomeFantasia != "")
                  name = solicitacao.Empresa.NomeFantasia;
                else
                  name = solicitacao.Empresa.RazaoSocial;
              }

              return name;
          },
        
        
        CalcIR(darf) {

            
                var solicitacao = darf.Solicitacao;
                var fatura = darf.Fatura.IndiceFatura + 1;
                var reserva= darf.ReservaInvestimento;
                var juros= darf.Carteira.Juros == undefined ? 0 : darf.Carteira.Juros;


              let aliqIR;
              let ipmt;

              if(solicitacao != null || solicitacao != undefined) {
                 ipmt = -this.IPMT(solicitacao.RetornoBrutoMensal / 100, fatura, solicitacao.Prazo, reserva.Valor);
                 ipmt = Math.round(ipmt * 100) / 100;
              }

              if(fatura >= 1 && fatura < 6) aliqIR = 0.225;
              else if(fatura >= 6 && fatura < 12) aliqIR = 0.2;
              else if(fatura >= 12 && fatura < 24) aliqIR = 0.175;
              else aliqIR = 0.15;

              if(juros == undefined || juros == null)
                 juros = 0;


              return this.formatCurrency((ipmt + juros) * aliqIR);
              
            },
            IPMT(rate, period, periods, present, future, type) {
              // Credits: algorithm inspired by Apache OpenOffice

              // Initialize type
              type = (typeof type === 'undefined') ? 0 : type;

              // Initialize future
              future = (typeof future === 'undefined') ? 0 : future;

              // Evaluate rate and periods (TODO: replace with secure expression evaluator)
              rate = eval(rate);
              periods = eval(periods);

              // Compute payment
              var payment = this.PMT(rate, periods, present, future, type);

              // Compute interest
              var interest;
              if (period === 1) {
                if (type === 1) {
                  interest = 0;
                } else {
                  interest = -present;
                }
              } else {
                if (type === 1) {
                  interest = this.FV(rate, period - 2, payment, present, 1) - payment;
                } else {
                  interest = this.FV(rate, period - 1, payment, present, 0);
                }
              }

              var result = interest * rate;
              // result = Math.round(result * 100) / 100;

              // Return interest
              return interest * rate;
            },
            PMT(rate, periods, present, future, type) {
                // Credits: algorithm inspired by Apache OpenOffice

                // Initialize type
                type = (typeof type === 'undefined') ? 0 : type;

                // Initialize future
                future = 0;

                // Evaluate rate (TODO: replace with secure expression evaluator)
                rate = eval(rate);

                // Return payment
                var result;
                if (rate === 0) {
                result = (present + future) / periods;
                } else {
                var term = Math.pow(1 + rate, periods);
                if (type === 1) {
                result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
                } else {
                result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
                }
                }

                // result = Math.round(result * 100) / 100;

                return -result;
            },
             VerificarDarf(op, wallet) {
              
             
                var indiceFatura = op.FaturaID.IndiceFatura;
                var ir = 0;
                
                for(var i = 0 ; i < indiceFatura ; i++){

                    var juros = 0
                    if(op.FaturaID != null){
                 
                        juros = this.EncontrarJuros(op.FaturaID._id, i, wallet)
                    }
                    
                    var darf = {};
                    darf.Solicitacao = op.SolicitacaoID, 
                    darf.Fatura = {};
                    darf.Fatura.IndiceFatura = i 
                    darf.ReservaInvestimento = op.ReservaInvestimentoID
                    darf.Carteira = {}
                    darf.Carteira.Juros = juros
                        

                    var vIR  = this.CalcIR(darf)

                    vIR =vIR.replace(/\./g,'');
                    vIR = vIR.replace(',','.')
                    
                    ir += parseFloat(vIR)
                    if(ir > 10)
                        ir = 0
                }

                var darf = {};
                darf.Solicitacao = op.SolicitacaoID, 
                darf.Fatura = {};
                darf.Fatura.IndiceFatura = indiceFatura
                darf.ReservaInvestimento = op.ReservaInvestimentoID
                darf.Carteira = {}
                darf.Carteira.Juros = op.Juros == undefined ? 0 : op.Juros;

                var vIR  = this.CalcIR(darf)
                vIR = vIR.replace(/\./g,'');
                vIR = vIR.replace(',','.')
                ir += parseFloat(vIR)

                // op.IR = ir;
                // if(ir >= 10)
                //     return ir
                return this.formatCurrency(ir);
             
          },

         EncontrarJuros(faturaID, indice, wallet) {
              
              for(var i = 0; i < wallet.length; i++ )
              {
                  if(wallet[i].FaturaID != null && wallet[i].FaturaID != undefined && wallet[i].FaturaID._id == faturaID && wallet[i].FaturaID.IndiceFatura == indice )
                  {
                      return wallet[i].Juros;
                  }
              }  

              return 0;
          },
             formatCurrency(value) {
                if(value != null)
                {
                    if(typeof value  == "string")
                        value = parseFloat(value)

                    value = parseInt(value * 100) / 100.0

                     
                    return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})
                }

                return 0;
            },
            FV(rate, periods, payment, value, type) {
              // Credits: algorithm inspired by Apache OpenOffice

              // Initialize type
              type = (typeof type === 'undefined') ? 0 : type;

              // Evaluate rate (TODO: replace with secure expression evaluator)
              rate = eval(rate);

              // Return future value
              var result;
              if (rate === 0) {
                result = value + payment * periods;
              } else {
                var term = Math.pow(1 + rate, periods);
                if (type === 1) {
                  result = value * term + payment * (1 + rate) * (term - 1.0) / rate;
                } else {
                  result = value * term + payment * (term - 1) / rate;
                }
              }

              // result = Math.round(result * 100) / 100;

              return -result;
            },
             getYear(data) {
                let aux = data.split("T");
                let day = aux[0].split("-");

                return day[0];
            },
            getMonth(data) {
                let aux = data.split("T");
                let month = aux[0].split("-");

                return month[1];
            },
             getDataApuracao(data) {

                if(data == undefined)
                    return ""

                var d2 = new Date(data)
                var dIR = new Date()

                if(d2.getDate() < 11)
                {
                    dIR = new Date(d2.getFullYear(),d2.getMonth(),11)
                }
                else{

                    if(d2.getDate() < 21)
                        dIR = new Date(d2.getFullYear(),d2.getMonth(),21)
                    else
                        dIR = new Date(d2.getFullYear(),d2.getMonth()+1,1)
                }


                ApiHub.ConsultaTerceiroDiaUtil(dIR.getDate(),dIR.getMonth()+1,dIR.getFullYear()).then((resp)=>
                {
                    dIR = new Date(resp.data);
                    dIR.setHours(dIR.getHours() + 4)

                    var dia = dIR.getDate()+""
                    if(dia.length < 2)
                        dia ="0"+dia
                    var mes = (dIR.getMonth()+1)+""
                    if(mes.length < 2)
                        mes ="0"+mes
                    var ano = dIR.getFullYear()

                    this.DataVencimento = dia +"/"+ mes+ "/" + ano;
                
                })

                return ""
              
            },
             getDataVencimento(data) {

                if(data == undefined)
                    return " "
                    
                var d = new Date(data)

                var dia = d.getDate()
                if(dia.length < 2)
                    dia ="0"+dia
                var mes = (d.getMonth()+1)+""
                if(mes.length < 2)
                    mes ="0"+mes
                var ano = d.getFullYear()

                console.log(dia, mes, ano)

                return dia +"/"+ mes+ "/" + ano;

                // d = new Date(d.getFullYear(),d.getMonth(),d.getDate());
                // var d2 = d

                // var dia = d2.getDate()

                // if(dia < 10)
                //     dia= 10
                // else
                // { 
                //     if(dia < 20)
                //         dia= 20
                //     else
                //         dia= 1
                // }
                // var mes = this.getMonth(d.toISOString())+""
                // if(mes.length < 2)
                //     mes ="0"+mes
                // var ano = this.getYear(d.toISOString())

                // if(dia == 1)
                // {
                //     d.setMonth(d.getMonth()+1);
                //     d.setDate(0)
                //     dia = d.getDate();
                // }


               return dia +"/"+ mes+ "/" + ano;
            },
            formatCPF(cpf){
               return  cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
            },

        //tagueamento GA
        taggingGA() {
            this.$ga.page({
                page: '/darf/:id/:idINV/ ',
                title: 'DARF',
            })
        },
    },

    async created() {

        var transactionID = this.$route.params.id
        var invID = this.$route.params.idINV

        ApiClientGo.getInfoDarf(transactionID).then(response => {

                this.infosDarf = response.data;
               
                this.encontrado = true;

                ApiClient.getAllWallet(invID)
                .then(infos => {
                        var  Wallet = infos.data.Carteira.sort(function(a, b) {
                            if(a.Data < b.Data) {
                                return 1;
                            } else if(a.Data > b.Data) {
                                return -1
                            } else {
                                return 0
                            }
                        });

                        var repagAtual;

                        for(var i = 0 ; i < Wallet.length ; i++)
                        {
                            if(Wallet[i]._id == transactionID)
                            {
                                repagAtual = Wallet[i];

                                this.PagAtual = repagAtual;

                                break;
                            }
                        }

                       this.infosDarf.Valor = this.VerificarDarf(repagAtual,Wallet);

                       this.$forceUpdate();


                }).catch((ex) => {
                    console.log(":-(   ", ex)
                                this.Naoencontrado = true;
                                this.$store.commit(mutationTypes.STOP_LOADING);
                                })

            }).catch(() => {
                this.Naoencontrado = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })


          window.onafterprint = function(){
                  document.getElementById('sumir').style='';
                } 

            //tagueamento GA
            await this.taggingGA();    
        }
    }
</script>


<style lang="scss" scoped>

    .ico-iouu {
        color: #41d3bd;
        font-size: 100px;
    }

    h1 {
        font-size: 30px;
        line-height: 30px;
        margin-left: 15px;
    }
    .align-right{
        text-align: right;
    }

    .btn {
        font-weight: bold;
        font-size: 14px;
        text-transform: uppercase;
        display: flex;
        flex-direction: row;
        align-items: center;

        i {
            padding-right: 8px;
        }

        &-link {
            color: #999;
            i {
                font-size: 18px;
                color: #41d3bd;
                margin-top: 2px;
            }
            &:hover {
                color: #41d3bd;
                text-decoration: none!important;
            }
        }
    }
    .divider {
        display: block;
        height: 1px;
        width: 100%;
        background: #ddd;
        margin: 20px 0;
        flex: 0 0 75%;
	    max-width: 75%;
    }

    .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

     .item-center-darf {
        text-align: center;
    }

    .item-header {
        display: flex;
        justify-content: flex-start;
        position: relative;

        figure {
            margin:0 10px 0 0;
            padding: 0px;

            img {
                width: 110px;
                height: 110px;
                height: auto!important;
            }
        }

        strong {
            display: block;

            &:nth-child(1) {
                padding-top: 10px;
                font-size: 18px;
                line-height: 20px;
            }
            &:nth-child(2) {
                font-size: 11px;
                line-height: 11px;
            }
            &:nth-child(3) {
                position: absolute;
                bottom: -10px;
                font-size: 36px;
                line-height: 36px;
            }
        }
    }

    p {
        color: #000;
        display: block;
        margin:0px;
    }


    table {
        border-collapse: collapse;
        width: 100%;

        td {
            border: 1px solid #000;
            padding: 8px;

            &:nth-child(1) {
                width: 45%;
            }
            &:nth-child(2),
            &:nth-child(3) {
                width: calc( 55% / 2);
            }
            span {
                display: flex;
                strong {
                    font-size: 22px;
                    line-height: 22px;
                    padding-bottom: 10px;
                    padding-right: 5px;
                }
                small {
                    font-size: 10px;
                }
            }
        }
    }

    @media print {

        .ico-iouu {
            font-size: 50px;
            line-height: 50px;
        }

        h1 {
            font-size: 14px;
        }

        .item-header {
            display: flex;
            justify-content: flex-start;
            position: relative;

            figure {
                margin-right: 5px;
                img {
                    width: 65px;
                    height: auto;
                }
            }

            strong {
                display: block;

                &:nth-child(1) {
                    padding-top: 5px;
                    font-size: 12px;
                    line-height: 15px;
                }
                &:nth-child(2) {
                    font-size: 8px;
                    line-height: 8px;
                }
                &:nth-child(3) {
                    position: absolute;
                    bottom: -10px;
                    font-size: 20px;
                    line-height: 20px;
                }
            }
        }

        p { 
            padding:0 8px;
            font-size: 10px;
        }

        .atencao {
            strong {
                font-size:12px;
            }
            p {
                font-size: 8px;
            }
        }

        .item {
            padding-left: 5px;
            padding-right: 5px;
        }

        .m-print {
            padding-left: 5px;
        }

        table {
            td {
                padding: 2px;
                span {
                    font-size: 10px;
                    strong {
                        display: block;
                        font-size: 12px;
                        line-height: 12px;
                        padding-bottom:0px;
                        padding-right: 5px;
                        margin:0px;
                    }
                    small {
                        font-size: 6px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Darf.vue